import { STRUCTURE } from "../data/content";
import { Reveal } from "./Reveal";

const StructureCard = ({ role, names, pending = false, className = "" }) => (
    <article className={`org-card ${className}`}>
        <h3 className="org-card__role">{role}</h3>
        <div className="org-card__names">
            {pending ? (
                <p className="text-bh-gray">Informasi segera diperbarui</p>
            ) : (
                names.map((name) => <p key={name}>{name}</p>)
            )}
        </div>
    </article>
);

export const Structure = () => (
    <section
        id="kelembagaan"
        data-testid="struktur-section"
        aria-labelledby="struktur-title"
        className="bg-white py-16 sm:py-20 scroll-mt-20 overflow-hidden"
    >
        <div className="mx-auto max-w-[1100px] px-6 sm:px-8">
            <Reveal>
                <header className="mb-10 text-center sm:mb-12">
                    <p className="mb-3 text-xs font-semibold uppercase tracking-[0.28em] text-bh-gold">
                        {STRUCTURE.eyebrow}
                    </p>
                    <h2
                        id="struktur-title"
                        data-testid="struktur-title"
                        className="font-serif text-2xl font-bold tracking-tight text-bh-deep sm:text-3xl lg:text-4xl"
                    >
                        {STRUCTURE.title}
                    </h2>
                    <span
                        aria-hidden="true"
                        className="mx-auto mt-4 block h-[2px] w-14 bg-bh-gold"
                    />
                    <p className="mt-3 text-base text-bh-gray sm:text-lg">{STRUCTURE.sub}</p>
                </header>
            </Reveal>

            <Reveal>
                <div
                    className="org-chart"
                    role="group"
                    aria-label="Bagan struktur kepengurusan Yayasan Baitul Haq"
                    data-testid="struktur-chart"
                >
                    <div className="org-pair">
                        {STRUCTURE.supervisors.map((member) => (
                            <StructureCard key={member.role} {...member} />
                        ))}
                    </div>

                    <div className="org-chair">
                        <StructureCard {...STRUCTURE.chair} />
                    </div>

                    <div className="org-management">
                        <div className="org-admin">
                            {STRUCTURE.executives.map((member) => (
                                <StructureCard key={member.role} {...member} />
                            ))}
                        </div>
                        <div className="org-units">
                            {STRUCTURE.units.map((member) => (
                                <StructureCard key={member.role} {...member} />
                            ))}
                        </div>
                    </div>
                </div>
            </Reveal>
        </div>
    </section>
);
